import { memo, useCallback } from 'react';

import { MassMessageSpace } from 'models';

import { Checkbox } from 'components';
import { SpaceIcon } from 'components/icons';

import { useStyles as useCommonStyles } from '../style';

interface SpaceItemProps {
  space: MassMessageSpace;
  disabled: boolean;
  selected: boolean;
  onSelectSpace?: (space: MassMessageSpace[], checked: boolean) => void;
}

const SpaceItem = ({
  space,
  onSelectSpace,
  selected,
  disabled,
}: SpaceItemProps) => {
  const commonClasses = useCommonStyles();

  const handleSelectSpace = useCallback(() => {
    if (onSelectSpace) {
      onSelectSpace([space], !selected);
    }
  }, [space, selected, onSelectSpace]);

  return (
    <li className={commonClasses.li}>
      <div className={commonClasses.bar}>
        <div className={commonClasses.mock}></div>
        <SpaceIcon className={commonClasses.mainIcon} />
        <Checkbox
          disabled={disabled}
          checked={selected}
          onChange={handleSelectSpace}
        />
        <span className={commonClasses.text}>{space.Name}</span>
      </div>
    </li>
  );
};

export default memo(SpaceItem);
